import React from 'react'
import { useAppKit, useAppKitState, useAppKitNetwork } from '@reown/appkit/react'

const chainImages = {
  1: 'https://nominex.io/static/filters:format(webp)/s.nominex.io/images/icons/networks/ethereum.png',
  56: 'https://nominex.io/static/filters:format(webp)/s.nominex.io/images/icons/networks/bsc.png',
  137: 'https://nominex.io/static/filters:format(webp)/s.nominex.io/images/icons/networks/matic.png',
}

const MobileWeb3NetworkSwitch: React.FC = () => {
  const { open } = useAppKit()
  const { selectedNetworkId } = useAppKitState()
  const { caipNetwork } = useAppKitNetwork()

  const handleClick = () => {
    open({ view: 'Networks' })
  }

  const networkId = selectedNetworkId || caipNetwork?.id
  const networkName = caipNetwork?.name || 'Network'

  return (
    <div
      className="flex items-center justify-center bg-blue h-[38px] w-[38px] rounded-10 cursor-pointer"
      onClick={handleClick}
      onKeyDown={handleClick}
      role="button"
      tabIndex={0}
    >
      <div className="overflow-hidden rounded-full">
        <img className="h-24 w-24" src={chainImages[networkId]} alt={networkName} />
      </div>
    </div>
  )
}

export default MobileWeb3NetworkSwitch
